module.exports = __webpack_public_path__ + "static/media/logo-ecityclic.a6af3f33.svg";